const React = require("react");
const T = require("prop-types");
const RaisedButton = require("material-ui/RaisedButton").default;
const TextField = require("material-ui/TextField").default;
const NavLink = require("react-router-dom").NavLink;
const IsEmail = require("utils/is-email");
const Paper = require("material-ui/Paper").default;

const internals = {};

internals.paperStyle = {
    padding: "3rem",
    margin: "4rem 0"
};

module.exports = class PasswordReset extends React.Component {
    static propTypes = {
        onSubmit: T.func.isRequired
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            email: "",
            emailError: null
        };

        this.emailChanged = this._emailChanged.bind(this);
        this.validateEmail = this._validateEmail.bind(this);
        this.submitOrError = this._submitOrError.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    _emailChanged(ev) {
        this.setState({ email: ev.target.value });
    }

    _validateEmail(ev, cb) {
        cb = cb || (() => null);

        const email = ev ? ev.target.value : this.state.email;

        if (!email) {
            return this.setState({ emailError: "Email is required" }, cb);
        }

        if (!IsEmail(email)) {
            return this.setState({ emailError: "Invalid email address" }, cb);
        }

        return this.setState({ emailError: null }, cb);
    }

    _submitOrError(ev) {
        this.validateEmail(null, () => {
            if (this.state.emailError) {
                return;
            }

            return this.props.onSubmit(this.state.email);
        });

        ev.preventDefault();
    }

    render() {
        return (
            <Paper style={internals.paperStyle}>
                <form onSubmit={this.submitOrError}>
                    <h2>Forgot your password?</h2>
                    <p>
                        To reset your password, enter your email below and we
                        will email a link to reset your password.
                    </p>
                    <div className="form-group">
                        <TextField
                            type="email"
                            floatingLabelText="Email"
                            value={this.state.email}
                            errorText={this.state.emailError}
                            onBlur={this.validateEmail}
                            onChange={this.emailChanged}
                        />
                    </div>
                    <RaisedButton
                        primary
                        label="Reset Password"
                        onClick={this.submitOrError}
                        labelStyle={{
                            textTransform: "inherit"
                        }}
                        type="submit"
                    />
                    <div className="form-subnote">
                        <NavLink to="/login">Login</NavLink>
                    </div>
                </form>
            </Paper>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/forgot-password/components/ForgotPassword.js